import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  mariageAgent:[],
  mariageSurcussale:[],
  AmountmariageAgent:[],
  
  AmountmariageSurcussale:[],
  countries: [],
  city: [],
  lotto: [],
  agents: [],
  supervisors: [],
  surcussales: [],
  tirages: [],
  tirageStatus: [],
  tirageStatus2: [],
  fiches: [],
  fichesupps: [],
  fichegagnants: [],
  borletteConf: [],
  transaction: [],
  intervalleOption:[],
  typeGame: [],
  typeGameAgent: [],
  
  intervalemas:[],
  typeGameSurcussale: [],
  typeBoule: [],
  typeBouleAgent: [],
  limitsAB: null,
  limitsBP: null,
  limitsBPT: null,
  limitsGrappa:null,
  primeConfs: null,
  tirageprimeConfs: [],
  agentprimeConfs: [],
  succprimeConfs: [],
  app: null,
  appJournalier: null,
  appTirageLotgagnant: [],
  appTirage: null,
  appFiche: null,
  appLotto: null,
  appGain: null,
  appGpc: null,
  infotirages: [],
  infotiragesglo: [],
  boules: [],
  statistiques: [],
  tracabiliteAgent: [],
  tracabiliteSupervisor: [],
  tracabiliteCompany: [],
  info_tirages: [],
  rapports: [],
  rapportagents: [],
  agentRapport: [],
  supRapport: [],
  agentsupRapport: null,
  lotgagnants: [],
  compagnies: [],
  companyPayment: [],
  promote: [],
  facturations: [],
  tchalas:[],
  companyStatus:[],
  fichesTirage:[],
  rapportsTirage:[],
  rapportsBeTirage:[]
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET COUNTRIES
    getCountriesSuccess(state, action) {
      state.isLoading = false;
      state.countries = action.payload;
    },

    // GET CITY
    getCitySuccess(state, action) {
      state.isLoading = false;
      state.city = action.payload;
    },

    // GET LOTTO
    getLottoSuccess(state, action) {
      state.isLoading = false;
      state.lotto = action.payload;
    },

    // GET AGENTS
    getAgentsSuccess(state, action) {
      state.isLoading = false;
      state.agents = action.payload;
    },

    // GET SUPERVISORS
    getSupervisorsSuccess(state, action) {
      state.isLoading = false;
      state.supervisors = action.payload;
    },

    // GET SURCUSSALES
    getSurcussaleSuccess(state, action) {
      state.isLoading = false;
      state.surcussales = action.payload;
    },

    // GET TIRAGES
    getTirageSuccess(state, action) {
      state.isLoading = false;
      state.tirages = action.payload;
    },

    getTirageStatusSuccess(state, action) {
      state.isLoading = false;
      state.tirageStatus = action.payload;
    },

    getTirageStatus2Success(state, action) {
      state.isLoading = false;
      state.tirageStatus2 = action.payload;
    },

    // GET FICHES
    getFicheSuccess(state, action) {
      state.isLoading = false;
      state.fiches = action.payload;
    },

    getFicheTirageSuccess(state, action) {
      state.isLoading = false;
      state.fichesTirage = action.payload;
    },

    // GET FICHES GAGNANTS
    getFicheGagnantSuccess(state, action) {
      state.isLoading = false;
      state.fichegagnants = action.payload;
    },

    // GET FICHES SUPP
    getFicheSuppSuccess(state, action) {
      state.isLoading = false;
      state.fichesupps = action.payload;
    },

    // GET BOULES
    getBouleSuccess(state, action) {
      state.isLoading = false;
      state.boules = action.payload;
    },

    // GET LIMIT ALL BOULES
    getLimitAllBouleSuccess(state, action) {
      state.isLoading = false;
      state.limitsAB = action.payload;
    },

    // GET LIMIT BOULES PAIRE
    getLimitBoulePaireSuccess(state, action) {
      state.isLoading = false;
      state.limitsBP = action.payload;
    },

    // GET LIMIT BOULES POINTS
    getLimitBoulePointSuccess(state, action) {
      state.isLoading = false;
      state.limitsBPT = action.payload;
    },

    // GET LIMIT BOULES POINTS
    getLimitBouleGrappesSuccess(state, action) {
      state.isLoading = false;
      state.limitsGrappa = action.payload;
    },

    // GET PRIMECONF
    getPrimeConfSuccess(state, action) {
      state.isLoading = false;
      state.primeConfs = action.payload;
    },

    // GET TIRAGECONF
    getTirageConfSuccess(state, action) {
      state.isLoading = false;
      state.tirageprimeConfs = action.payload;
    },

    // GET AGENTCONF
    getAgentConfSuccess(state, action) {
      state.isLoading = false;
      state.agentprimeConfs = action.payload;
    },

    // GET SUCCCONF
    getSuccConfSuccess(state, action) {
      state.isLoading = false;
      state.succprimeConfs = action.payload;
    },

    // GET APP
    getAppSuccess(state, action) {
      state.isLoading = false;
      state.app = action.payload;
    },

    // GET APP JOURNALIER
    getAppJournalierSuccess(state, action) {
      state.isLoading = false;
      state.appJournalier = action.payload;
    },

    // GET RAPPORT BY AGENT
    getAgentRapportSuccess(state, action) {
      state.isLoading = false;
      state.agentRapport = action.payload;
    },

    // GET RAPPORT BY SUPERVISOR
    getSupRapportSuccess(state, action) {
      state.isLoading = false;
      state.supRapport = action.payload;
    },

    // GET RAPPORT AG + SUPERVISOR
    getASRapportSuccess(state, action) {
      state.isLoading = false;
      state.agentsupRapport = action.payload;
    },

    // GET APP LOT Gagnant
    getAppTirageLotGagnantSuccess(state, action) {
      state.isLoading = false;
      state.appTirageLotgagnant = action.payload;
    },

    // GET APP TIRAGE
    getAppTirageSuccess(state, action) {
      state.isLoading = false;
      state.appTirage = action.payload;
    },

    // GET APP FICHE
    getAppFicheSuccess(state, action) {
      state.isLoading = false;
      state.appFiche = action.payload;
    },

    // GET APP LOTTO
    getAppLottoSuccess(state, action) {
      state.isLoading = false;
      state.appLotto = action.payload;
    },

    // GET APP GAIN
    getAppGainSuccess(state, action) {
      state.isLoading = false;
      state.appGain = action.payload;
    },

    // GET APP GPC
    getAppGpcSuccess(state, action) {
      state.isLoading = false;
      state.appGpc = action.payload;
    },

    // GET INTERVALLE OPTION
    getIntervalleOptionSuccess(state, action) {
      state.isLoading = false;
      state.intervalleOption = action.payload;
    },

    // GET TYPEGAME
    getTypeGameSuccess(state, action) {
      state.isLoading = false;
      state.typeGame = action.payload;
    },

    // GET TYPEGAMEAGENT
    getTypeGameAgentSuccess(state, action) {
      state.isLoading = false;
      state.typeGameAgent = action.payload;
    },

        getTypeGameSurcussaleSuccess(state, action) {
      state.isLoading = false;
      state.typeGameSurcussale = action.payload;
    },

    // GET TYPEBOULE
    getTypeBouleSuccess(state, action) {
      state.isLoading = false;
      state.typeBoule = action.payload;
    },

    // GET TYPEBOULEAGENT
    getTypeBouleAgentSuccess(state, action) {
      state.isLoading = false;
      state.typeBouleAgent = action.payload;
    },

    // GET INFOTIRAGE
    getInfoTirageSuccess(state, action) {
      state.isLoading = false;
      state.infotirages = action.payload;
    },

    // GET INFOTIRAGE GLOBALE
    getInfoTirageGloSuccess(state, action) {
      state.isLoading = false;
      state.infotiragesglo = action.payload;
    },

    // GET STATISTIQUES
    getStatistiqueSuccess(state, action) {
      state.isLoading = false;
      state.statistiques = action.payload;
    },

    getIntervalMaSuccess(state, action) {
      state.isLoading = false;
      state.intervalemas = action.payload;
    },
    // GET TRANSACTION
    getTransactionSuccess(state, action) {
      state.isLoading = false;
      state.transaction = action.payload;
    },

    // GET TRACABILITE AGENTS
    getTracabiliteAgentSuccess(state, action) {
      state.isLoading = false;
      state.tracabiliteAgent = action.payload;
    },

    // GET TRACABILITE SUPERVISORS
    getTracabiliteSupervisorSuccess(state, action) {
      state.isLoading = false;
      state.tracabiliteSupervisor = action.payload;
    },

    // GET TRACABILITE COMPANIES
    getTracabiliteCompanySuccess(state, action) {
      state.isLoading = false;
      state.tracabiliteCompany = action.payload;
    },

    // GET RAPPORTS
    getRapportSuccess(state, action) {
      state.isLoading = false;
      state.rapports = action.payload;
    },

    getRapporTiragetSuccess(state, action) {
      state.isLoading = false;
      state.rapportsTirage = action.payload;
    },

    getRapporAvantTiragetSuccess(state, action) {
      state.isLoading = false;
      state.rapportsBeTirage = action.payload;
    },


    // GET RAPPORTS
    getRapportAgentSuccess(state, action) {
      state.isLoading = false;
      state.rapportagents = action.payload;
    },

    // GET LOT GAGNANTS
    getLotGagnantSuccess(state, action) {
      state.isLoading = false;
      state.lotgagnants = action.payload;
    },

    // GET LOT COMPAGNIES
    getCompagniesSuccess(state, action) {
      state.isLoading = false;
      state.compagnies = action.payload;
    },

    // GET LOT COMPANY PAYMENT
    getCompanyPaymentSuccess(state, action) {
      state.isLoading = false;
      state.companyPayment = action.payload;
    },

    // GET LOT COMPANY PAYMENT
    getCompanyStatusSuccess(state, action) {
      state.isLoading = false;
      state.companyStatus = action.payload;
    },

    // GET LOT MESSAGE
    getMessageSuccess(state, action) {
      state.isLoading = false;
      state.promote = action.payload;
    },
    
    getmariageAgentSuccess(state, action) {
      state.isLoading = false;
      state.mariageAgent = action.payload;
    },
    // GET FACTURATION
    getFacturationSuccess(state, action) {
      state.isLoading = false;
      state.facturations = action.payload;
    },

    getmariageSurcussaleSuccess(state, action) {
      state.isLoading = false;
      state.mariageSurcussale = action.payload;
    },
    getAmountmariageSurcussaleSuccess(state, action) {
      state.isLoading = false;
      state.AmountmariageSurcussale = action.payload;
    },
    getAmountmariageAgentSuccess(state, action) {
      state.isLoading = false;
      state.AmountmariageAgent= action.payload;
    },
    getTchalaSuccess(state, action) {
      state.isLoading = false;
      state.tchalas = action.payload;
    },
    
  }
});

// Reducer
export default slice.reducer;

// Actions
// export const { onToggleFollow, deleteUser } = slice.actions;

// ----------------------------------------------------------------------


export function getTchalasPage(url) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // let url = 'api/tchalas/?limit=1&page=1';
     
      const response = await axios.get(url);
      dispatch(slice.actions.getTchalaSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}


export function getTchalas(name = null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let url = '/api/tchalas';
      if (name) {
        url += `?name=${name}`;
      }
      const response = await axios.get(url);
      dispatch(slice.actions.getTchalaSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}


export function getAmountMariageAgent() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/companies/amount-mariage-agent');
      dispatch(slice.actions.getAmountmariageAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}



export function getAmountMariageSurcussale() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/companies/amount-mariage-surcussale');
      dispatch(slice.actions.getAmountmariageSurcussaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getListIntervalma() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-interval-ma`);
      dispatch(slice.actions.getIntervalMaSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getMariageSurcussale() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/companies/prime-mariage-surcussale');
      dispatch(slice.actions.getmariageSurcussaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}




export function getMariageAgent() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/companies/prime-mariage-agent');
      dispatch(slice.actions.getmariageAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}


export function getCountries() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/generals/countries');
      dispatch(slice.actions.getCountriesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCity() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/generals/cities');
      dispatch(slice.actions.getCitySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getLottos() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-lotto`);
      dispatch(slice.actions.getLottoSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAgents(params = {}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-agent`, {
        params: params // Passer les paramètres de requête
      });
      dispatch(slice.actions.getAgentsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSupervisors() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-supervisor`);
      dispatch(slice.actions.getSupervisorsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSurcussales() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-surcussale`);
      dispatch(slice.actions.getSurcussaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTiragesStatus(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/tirages-status?start_date=${value}&end_date=${value1}`);
      dispatch(slice.actions.getTirageStatusSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getTiragesStatus2(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/tirages-status2?start_date=${value}&end_date=${value1}`);
      dispatch(slice.actions.getTirageStatus2Success(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}


export function getTirages(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/list-tirage?start_date=${value}&end_date=${value1}`);
      dispatch(slice.actions.getTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getFicheTirages(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/fiche-tirages?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getFicheTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}





export function getFiches(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/fiche?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}`
      );
      dispatch(slice.actions.getFicheSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getFicheGagnants(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // Convertir les arrays en strings pour l'URL
      const tirageId = Array.isArray(value2) ? value2.join(',') : value2;
      const surcussaleId = Array.isArray(value3) ? value3.join(',') : value3;
      const agentId = Array.isArray(value4) ? value4.join(',') : value4;
      
      const response = await axios.get(
        `/api/companies/fiche-gagnants?start_date=${value}&end_date=${value1}&tirage_id=${tirageId}&surcussale_id=${surcussaleId}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getFicheGagnantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getFicheSupps(value, value1, value2, value3, value4) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // Convertir les arrays en strings pour l'URL
      const tirageId = Array.isArray(value2) ? value2.join(',') : value2;
      const surcussaleId = Array.isArray(value3) ? value3.join(',') : value3;
      const agentId = Array.isArray(value4) ? value4.join(',') : value4;
      
      const response = await axios.get(
        `/api/companies/fiche-supp?start_date=${value}&end_date=${value1}&tirage_id=${tirageId}&surcussale_id=${surcussaleId}&agent_id=${agentId}`
      );
      dispatch(slice.actions.getFicheSuppSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTypeGames() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/type-games`);
      dispatch(slice.actions.getTypeGameSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getIntervalleOptions() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/intervalle-option`);
      dispatch(slice.actions.getIntervalleOptionSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTypeGameAgents() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/type-games-agent`);
      dispatch(slice.actions.getTypeGameAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}




export function getTypeGameSurcussales() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/type-games-surcussale`);
      dispatch(slice.actions.getTypeGameSurcussaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTypeBoules() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/type-boules`);
      dispatch(slice.actions.getTypeBouleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTypeBouleAgents() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/type-boules-agent`);
      dispatch(slice.actions.getTypeBouleAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getBoules() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/boules-block`);
      dispatch(slice.actions.getBouleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getInfoTirages() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/info-tirage`);
      dispatch(slice.actions.getInfoTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getInfoTiragesGlo() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/generals/info-tirage`);
      dispatch(slice.actions.getInfoTirageGloSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getLimitAllBoule() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/limit-100-boules`);
      dispatch(slice.actions.getLimitAllBouleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getLimitBoulePaires() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/limit-boules-paires`);
      dispatch(slice.actions.getLimitBoulePaireSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------


export function getLimitGrappes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/limit-boules-grappes`);
      dispatch(slice.actions.getLimitBouleGrappesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getLimitBoulePoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/limit-boules-points`);
      dispatch(slice.actions.getLimitBoulePointSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getPrimeConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime`);
      dispatch(slice.actions.getPrimeConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTirageConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime-tirage`);
      dispatch(slice.actions.getTirageConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAgentConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime-agent`);
      dispatch(slice.actions.getAgentConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSuccConfs() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/prime-surcussale`);
      dispatch(slice.actions.getSuccConfSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getApp() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/app`);
      dispatch(slice.actions.getAppSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getAppJournalier() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/app-journalier`);
      dispatch(slice.actions.getAppJournalierSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAgentRapports() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/rapport-journalier`);
      dispatch(slice.actions.getAgentRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getSupRapports() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/rapport-journalier-sup`);
      dispatch(slice.actions.getSupRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getASRapports() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/rapport-journalier-ag-sup`);
      dispatch(slice.actions.getASRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppTirageLotgagnant() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appTirage-lotgagnant`);
      dispatch(slice.actions.getAppTirageLotGagnantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppTirage() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appTirage`);
      dispatch(slice.actions.getAppTirageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppFiche() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appFiche`);
      dispatch(slice.actions.getAppFicheSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppLotto() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appLotto`);
      dispatch(slice.actions.getAppLottoSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppGain() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appGain`);
      dispatch(slice.actions.getAppGainSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getAppGpc() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/appGpc`);
      dispatch(slice.actions.getAppGpcSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getRapports(value, value1, value2, value3, value4, value5) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapports?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}&filter_choice=${value5}`
      );
      dispatch(slice.actions.getRapportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}



export function getRapportsAvantTirage(value, value1, value2, value3, value4, value5) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapports-avant-tirage?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}&filter_choice=${value5}`
      );
      dispatch(slice.actions.getRapporAvantTiragetSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}


export function getRapportsVTirage(value, value1, value2, value3, value4, value5) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapports-tirage?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}&filter_choice=${value5}`
      );
      dispatch(slice.actions.getRapporTiragetSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getRapportAgents(value, value1, value2, value3, value4, value5) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/rapports-agent?start_date=${value}&end_date=${value1}&tirage_id=${value2}&surcussale_id=${value3}&agent_id=${value4}&filter_choice=${value5}`
      );
      dispatch(slice.actions.getRapportAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getStatistiques(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // Construire l'URL avec les paramètres
      const queryParams = new URLSearchParams();
      
      // Paramètres simples
      queryParams.append('start_date', params.start_date);
      queryParams.append('end_date', params.end_date);
      if (params.tirage_id) queryParams.append('tirage_id', params.tirage_id);
      if (params.lotto_id) queryParams.append('lotto_id', params.lotto_id);
      
      // Paramètres arrays (succursales et agents)
      if (params.surcussale_id && Array.isArray(params.surcussale_id)) {
        params.surcussale_id.forEach(id => {
          queryParams.append('surcussale_id[]', id);
        });
      }
      
      if (params.agent_id && Array.isArray(params.agent_id)) {
        params.agent_id.forEach(id => {
          queryParams.append('agent_id[]', id);
        });
      }

      const response = await axios.get(`/api/companies/statistiques?${queryParams.toString()}`);
      dispatch(slice.actions.getStatistiqueSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTransactions(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/transactions?start_date=${value}&end_date=${value1}`);
      dispatch(slice.actions.getTransactionSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTracabiliteAgents(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/tracabilites-agents?start_date=${value}&end_date=${value1}`);
      dispatch(slice.actions.getTracabiliteAgentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTracabiliteSupervisors(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/tracabilites-supervisors?start_date=${value}&end_date=${value1}`
      );
      dispatch(slice.actions.getTracabiliteSupervisorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

// ----------------------------------------------------------------------

export function getTracabiliteCompanies(value, value1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/tracabilites-companies?start_date=${value}&end_date=${value1}`);
      dispatch(slice.actions.getTracabiliteCompanySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getLotGagnants() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/lotgagnant`);
      dispatch(slice.actions.getLotGagnantSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCompagnies() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/generals/compagnies`);
      dispatch(slice.actions.getCompagniesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getSimpleCompagnies() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/generals/simple-compagnies`);
      dispatch(slice.actions.getCompagniesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCompanyPayment() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/historics-payment`);
      dispatch(slice.actions.getCompanyPaymentSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getCompanyStatus() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/companies-status`);
      dispatch(slice.actions.getCompanyStatusSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getMessages() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/companies/messages`);
      dispatch(slice.actions.getMessageSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}

export function getFacturations(value, value1, value2, which) {
  if (which === 'undefined') {
    which = 'superuser';
  }
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/companies/facturations?start_date=${value}&end_date=${value1}&company=${value2}&which=${which}`
      );
      dispatch(slice.actions.getFacturationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      if (error?.response?.status === 401) {
        delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
        window.location.reload();
      }
    }
  };
}
